<template>
    <v-menu
        transition="slide-y-transition"
        bottom
        color="white"
        open-on-hover offset-y
    >
        <template v-slot:activator="{ on }">
            <v-btn
                color="white"
                v-on="on"
                class="menu-principal--with-children"
                text
            >
                <v-icon size="15" class="icon-submenu" color="#7ce659"> mdi-leaf </v-icon>
                    {{ $t('ecoproductes') }}
                <icon-base icon-name="arrowDown" height="18" width="18"><arrowDown /></icon-base>
            </v-btn>
        </template>
        
        <!-- <submenu-item :menu="menu[3]"  /> -->
        <submenu-ecoproductes />
    </v-menu>
</template>

<script>

import IconBase from '@/components/elements/IconBase.vue'
import arrowDown from '@/assets/svg/arrowDown.vue'
// import SubmenuItem from '@/components/elements/SubmenuItem.vue'
import SubmenuEcoproductes from '@/components/menu/submenu/SubmenuEcoproductes.vue'

export default {
    name: 'MenuEcoproductes',
    components: {
        IconBase,
        arrowDown,
        // SubmenuItem,
        SubmenuEcoproductes
    },
    methods: {
        triggerClick: function (route){
        this.$router.push(route);
        }
    },
    computed: {
        rutas () {
            return this.$router.options.routes;
        },
        menu () {
            return this.$store.state.menu
        }
    }
    
}
</script>


<style scoped lang="scss">

  .icon-submenu {
    margin-right: 5px !important;
    padding-right: 0 !important;
    width: 20px !important;
    font-size: 20px !important;
  }

</style>